import { render, staticRenderFns } from "./BpbForm.vue?vue&type=template&id=86d25b66&scoped=true&"
import script from "./BpbForm.vue?vue&type=script&lang=js&"
export * from "./BpbForm.vue?vue&type=script&lang=js&"
import style0 from "./BpbForm.vue?vue&type=style&index=0&id=86d25b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d25b66",
  null
  
)

export default component.exports